module.exports = __webpack_public_path__ + "379c079bb86ba0ff5d94451069f4e8a0.jpg";